
import React from "react";
import { TableColumnsItem } from "../../interfaces/components/mainTable";
import { ColumnType, ButtonType } from "../utils/enums";
import { Medication } from "../../interfaces/api/medications";
import { Trash2 } from "lucide-react";

interface MedicationColumnHandlers {
  onDelete: (medication: Medication) => void;
}

const formatDate = (dateString: string) => {
  try {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  } catch (error) {
    return dateString;
  }
};

export const getMedicationsTableColumns = (
  handlers: MedicationColumnHandlers,
): TableColumnsItem[] => [
  {
    key: "name",
    name: "Medication Name",
    type: ColumnType.TEXT,
  },
  {
    key: "dosage",
    name: "Dosage",
    type: ColumnType.TEXT,
  },
  {
    key: "frequency",
    name: "Frequency",
    type: ColumnType.TEXT,
  },
  {
    key: "start_date",
    name: "Start Date",
    type: ColumnType.CUSTOM,
    customValue: (row: Medication) => formatDate(row.start_date),
  },
  {
    key: "end_date",
    name: "End Date",
    type: ColumnType.CUSTOM,
    customValue: (row: Medication) => formatDate(row.end_date),
  },
  {
    key: "is_active",
    name: "Status",
    type: ColumnType.CUSTOM,
    customValue: (row: Medication) => (row.is_active ? "Active" : "Inactive"),
  },
  {
    key: "actions",
    name: "Actions",
    type: ColumnType.BUTTON,
    buttonsList: [
      {
        type: ButtonType.ICON,
        icon: Trash2,
        onPress: (e: React.MouseEvent, row: Medication) => {
          e.stopPropagation();
          handlers.onDelete(row);
        },
      },
    ],
  },
]; 